module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "postsummary"
  }, [_c('a', {
    attrs: {
      "href": ("#/map?focus=" + _vm.table)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.table) ? _c('icon', {
    attrs: {
      "id": "location",
      "name": "map-o"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goMap(_vm.table)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "reaction"
  }, [_c('span', {
    staticClass: "raIcon"
  }, [_c('icon', {
    staticClass: "icon fa-icon-pointer",
    attrs: {
      "name": (_vm.isStaredByMe ? 'star' : 'star-o')
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleStar($event)
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "raCount"
  }, [_vm._v(_vm._s(_vm.starCount))])]), _vm._v(" "), _c('span', {
    staticClass: "reaction"
  }, [_c('span', {
    staticClass: "raIcon"
  }, [_c('icon', {
    staticClass: "fa-icon-pointer",
    attrs: {
      "name": (_vm.isLovedByMe ? 'heart' : 'heart-o')
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleHeart($event)
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "raCount"
  }, [_vm._v(_vm._s(_vm.heartCount))])]), _vm._v(" "), _c('a', {
    staticClass: "no-blue-link",
    attrs: {
      "href": '#/projects?id=' + _vm.postKey
    }
  }, [_c('h3', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('a', {
    staticClass: "no-blue-link",
    attrs: {
      "href": '#/projects?id=' + _vm.postKey
    }
  }, [_c('p', {
    staticClass: "description"
  }, [_c('strong', [_vm._v(_vm._s(_vm.host))]), _vm._v("\n      " + _vm._s(_vm.description) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "tags",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('el-button', {
      key: _vm.tags.indexOf(tag),
      staticClass: "button-new-tag",
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.$emit('tagClicked', tag)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tag) + "\n    ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8f919ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/hackingmap/postsummary.vue
// module id = 980
// module chunks = 1